module.exports = __webpack_public_path__ + "img/BI_10.952768fa.png";